import { connect } from 'react-redux';

import { changePage } from 'actions';

import ResultPage from './ResultPage';

const mapStateToProps = state => ({
    result: state.data.result,
    batting: state.data.batting,
    oppoBatting: state.data.oppoBatting,
    bowling: state.data.bowling,
    club: state.club
});

const mapDispatchToProps = dispatch => ({
    browserBack: (pathname, params) => dispatch(changePage(pathname, params))
});

const Result = connect(mapStateToProps, mapDispatchToProps)(ResultPage);

export default Result;



// WEBPACK FOOTER //
// ./src/views/result/index.js